import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, Gamepad2 } from "lucide-react";
import { CONTACT } from "@/data/content";

const LINKS = [
  { href: "#hizmetler", label: "Hizmetler" },
  { href: "#neden-biz", label: "Neden Biz" },
  { href: "#yorumlar", label: "Yorumlar" },
  { href: "#galeri", label: "Galeri" },
  { href: "#iletisim", label: "İletişim" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-slate-200/70 bg-white/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between lg:h-20">
          <a href="#anasayfa" data-testid="nav-logo" className="flex items-center">
            <img
              src="/logo.png"
              alt="Sistemli Otomotiv"
              className="h-9 w-auto lg:h-11"
              data-testid="nav-logo-img"
            />
          </a>

          <nav className="hidden items-center gap-8 lg:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="text-sm font-semibold text-slate-600 transition-colors hover:text-brand"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-4 lg:flex">
            <Link
              to="/oyun"
              data-testid="nav-game-btn"
              className="arcade-btn inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-extrabold uppercase tracking-wider"
            >
              <Gamepad2 className="h-4 w-4" />
              Oyun
            </Link>
            <a
              href={CONTACT.phoneHref}
              data-testid="nav-call-btn"
              className="inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-bold text-white shadow-soft transition-all hover:bg-brand-dark hover:shadow-lift"
            >
              <Phone className="h-4 w-4" />
              {CONTACT.phoneDisplay}
            </a>
          </div>

          <button
            type="button"
            data-testid="nav-menu-toggle"
            aria-label="Menüyü aç/kapat"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 text-slate-700 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-slate-100 bg-white px-4 pb-5 pt-2 lg:hidden">
          <nav className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                onClick={() => setOpen(false)}
                className="rounded-xl px-3 py-2.5 text-sm font-semibold text-slate-700 hover:bg-brand-softer hover:text-brand"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/oyun"
              data-testid="mobile-nav-game-btn"
              onClick={() => setOpen(false)}
              className="arcade-btn mt-2 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-extrabold uppercase tracking-wider"
            >
              <Gamepad2 className="h-4 w-4" />
              Yarış Oyunu
            </Link>
            <a
              href={CONTACT.phoneHref}
              data-testid="mobile-nav-call-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand px-5 py-3 text-sm font-bold text-white"
            >
              <Phone className="h-4 w-4" />
              Hemen Ara: {CONTACT.phoneDisplay}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
